import axios from '../../util/http/axios'
import useStore from '@/store'
import { AxiosRequestConfig } from 'axios'
import useModalStore from '@/store/modal'

export const useAxios = () => {
    const accessToken = useStore( ( { accessToken } ) => accessToken )
    return ( options: AxiosRequestConfig = {} ) => {
        const { headers } = options
        headers[ 'Authorization' ] = `Bearer ${accessToken}`
        return axios.getAxios()
    }
}

export const useAxiosRefreshToken: () => Promise<string>
    = async () => {
        const { data } =  await axios.get<string>( `/api/v1/auth/access/token` )
        return data
    }

export const redirectLogin: () => void = () => {
    window.location.href = '/login'
}

export type AixosPost = () => <T = any>( url: string, param: Record<string, any> , config?: AxiosRequestConfig ) => Promise<ResponseVo<T>>
export const useAxiosPost: AixosPost = () => {
    const { accessToken, setAccessToken } = useStore( ( { accessToken, setAccessToken } ) => ( { accessToken, setAccessToken } ) )
    const { loadingModalProps, setLoadingModalProps } = useModalStore()

    return <T = any>( url, param, config ) => {
        const { noLoading } = config || {}
        !noLoading && setLoadingModalProps( { ...loadingModalProps, isOpen: true } )

        return axios.post<T>( url, param, {
            headers: {
                'Authorization': `Bearer ${accessToken}`
            },
            ...config
        } ).catch( async ( { status, data } ) => {

            if( status === 401 ) {
                const reAccessToken = await useAxiosRefreshToken()
                setAccessToken( reAccessToken )

                return axios.post<T>( url, param, {
                    ...config,
                    headers: {
                        'Authorization': `Bearer ${reAccessToken}`
                    }
                } ).catch( () => {
                    redirectLogin()
                    return Promise.reject()
                } )
            } else {
                return Promise.reject( data )
            }
        } ).finally( () => {
            !noLoading && setLoadingModalProps( { ...loadingModalProps, isOpen: false } )
        } )
    }
}

export type AixosGet = () => <T = any>( url: string, config?: AxiosRequestConfig ) => Promise<ResponseVo<T>>
export const useAxiosGet: AixosGet = () => {
    const { accessToken, setAccessToken } = useStore( ( { accessToken, setAccessToken } ) => ( { accessToken, setAccessToken } ) )
    const { loadingModalProps, setLoadingModalProps } = useModalStore()

    return <T = any>( url, config ) => {
        const { noLoading } = config || {}
        !noLoading && setLoadingModalProps( { ...loadingModalProps, isOpen: true } )

        return axios.get<T>( url, {
            headers: {
                'Authorization': `Bearer ${accessToken}`
            },
            ...config
        } ).catch( async ( { status, data } ) => {
            if( status === 401 ) {
                const reAccessToken = await useAxiosRefreshToken()
                setAccessToken( reAccessToken )

                return axios.get<T>( url, {
                    ...config,
                    headers: {
                        'Authorization': `Bearer ${reAccessToken}`
                    }
                } ).catch( () => {
                    return Promise.reject()
                } )
            } else {
                return Promise.reject( data )
            }
        } ).finally( () => {
            !noLoading && setLoadingModalProps( { ...loadingModalProps, isOpen: false } )
        } )
    }
}

export type AixosMultiPart = () => <T = any>( url: string, form: FormData, config?: AxiosRequestConfig ) => Promise<ResponseVo<T>>
export const useAxiosMultipart: AixosMultiPart = () => {
    const { accessToken, setAccessToken } = useStore( ( { accessToken, setAccessToken } ) => ( { accessToken, setAccessToken } ) )
    const { loadingModalProps, setLoadingModalProps } = useModalStore()

    return <T = any>( url, form, config ) => {
        const { noLoading } = config || { timeout: 300000 }
        !noLoading && setLoadingModalProps( { ...loadingModalProps, isOpen: true } )

        return axios.multipart<T>( url, form, {
            headers: {
                'Authorization': `Bearer ${accessToken}`
            },
            ...config
        } ).catch( async ( { status, data } ) => {
            if( status === 401 ) {
                const reAccessToken = await useAxiosRefreshToken()
                setAccessToken( reAccessToken )

                return axios.multipart<T>( url, form, {
                    ...config,
                    headers: {
                        'Authorization': `Bearer ${reAccessToken}`
                    }
                } ).catch( () => {
                    return Promise.reject()
                } )
            } else {
                return Promise.reject( data )
            }

        } ).finally( () => {
            !noLoading && setLoadingModalProps( { ...loadingModalProps, isOpen: false } )
        } )
    }
}


